import { render } from "./SalesTab.vue?vue&type=template&id=07a5b9b7"
import script from "./SalesTab.vue?vue&type=script&lang=js"
export * from "./SalesTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__